import { isMobile } from "./isMobail";

export function fixButton(fixButtonEl, hideEl) {
  const $fixButton = $(fixButtonEl);
  getElementHeight("header", $fixButton);
  $(window).resize(function () {
    const $hideEl = $(hideEl).offset().top;
    const windowHeight = $(window).height();
    if (isMobile()) {
      $fixButton.css("top", "");
      $(window).scroll(function () {
        const $scrollTop = $(this).scrollTop();
        if ($scrollTop) {
          if ($scrollTop < $hideEl - windowHeight) {
            $fixButton.addClass("active");
          } else {
            $fixButton.removeClass("active");
          }
        }
      });
    }
  });
}

// headerのリサイズによって固定ボタンの位置調整
function getElementHeight(element, fixButton) {
  if (!isMobile()) {
    let height;
    const targetElement = document.getElementById(element);
    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const rect = entry.contentRect;
        height = `${rect.height}px`;
        fixButton.css("top", height);
      });
    });
    observer.observe(targetElement);
  }
}
